module.exports = __webpack_public_path__ + "img/error.f96d7eaf.gif";